/**
 * The application is made for a computer (a tablet at worst): on a phone, a screen explains it instead of the app.
 * A phone is a touch screen whose shortest side is under this width, in CSS pixels, whichever way it is held.
 * Tablets start at 600 (the Material breakpoint), so they keep the app.
 */
export const PHONE_SHORTEST_SIDE_MAX = 600

export interface ScreenDescription {
  width: number
  height: number
  /** Whether the primary pointer is a finger (`(pointer: coarse)`): a narrowed desktop window is never a phone. */
  coarsePointer: boolean
}

export function isPhoneScreen({ width, height, coarsePointer }: ScreenDescription): boolean {
  return coarsePointer && Math.min(width, height) < PHONE_SHORTEST_SIDE_MAX
}

const CONTINUE_ON_PHONE_KEY = "ttb-continue-on-phone"

/** Whether the user chose, in this browser session, to use the app on their phone anyway. */
export function isContinuingOnPhone(): boolean {
  try {
    return window.sessionStorage.getItem(CONTINUE_ON_PHONE_KEY) === "true"
  } catch {
    return false
  }
}

export function continueOnPhone(): void {
  try {
    window.sessionStorage.setItem(CONTINUE_ON_PHONE_KEY, "true")
  } catch {
    // the choice then only lasts as long as the page
  }
}
